import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { Observable } from "rxjs";
import { environment } from "../../../environments/environment";
import { Society } from "../models/society.model";

@Injectable()
export class SocietyService {

    societiesUrl = environment.dns + 'api/societies/';

    constructor(private http: HttpClient) { }

    getList(): Observable<Society[]> {
        return this.http.get<Society[]>(this.societiesUrl + 'list');
    }

}